import React, { ReactNode } from "react";
import Lottie from "lottie-react";
import {
  Container as ContainerMaterial,
  Box,
  Theme,
  SxProps,
} from "@mui/material";
import LoadingAnimation from "src/assets/json/loading.json";
import useWindowDimensions from "src/core/utils/dimensions";

type Props = {
  children: React.ReactNode;
  loading?: boolean;
  sx?: SxProps<Theme> | undefined;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
};

const ContainerContent = (props: Props) => {
  const { children, loading, sx, onScroll } = props;
  const { height } = useWindowDimensions();
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        height={height - 250}
        sx={sx}
      >
        <Lottie
          style={{
            width: 110,
            height: 110,
          }}
          animationData={LoadingAnimation}
          loop={true}
        />
      </Box>
    );
  }

  return <Box sx={{ width: "100%" }}>{children}</Box>;
};

export default ContainerContent;
